import {Component, EventEmitter, Input, Output} from '@angular/core';


@Component({
  selector: 'myvf-ui-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent {
  @Input() title: string;
  @Input() serviceNotify = true;
  @Input() retryLabel = 'Aggiorna';
  @Input() showRetryButton = true;
  @Input() closeLabel = 'Chiudi';
  @Input() showCloseButton = true;
  @Input() icon;
  @Input() headerColor;
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() close: EventEmitter<void> = new EventEmitter<void>();
  @Output() retry: EventEmitter<void> = new EventEmitter<void>();

  handleClose(): void {
  	this.close.emit();
  }

  handleRetry(): void {
  	this.retry.emit();
  }




}
